import { minimumLengthTest } from 'src/front/common/utils/validationSchemas';
import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required('general_requiredField_errorMessage')
    .test(minimumLengthTest(8, 'login_login_shortPassword_errorMessage')),
  newPassword: Yup.string()
    .when('oldPassword', (oldPassword: string, schema: Yup.StringSchema) =>
      schema
        .test(
          'fixed-length',
          'passwordChange_samePasswordControl_errorMessage',
          (val) => val !== oldPassword
        )
        .test(minimumLengthTest(8, 'login_login_shortPassword_errorMessage'))
    )
    .required('general_requiredField_errorMessage'),
  newPasswordConfirm: Yup.string()
    .required('general_requiredField_errorMessage')
    .equals([Yup.ref('newPassword'), null], 'passwordChange_passwordsDoNotMatch_errorMessage'),
});
